var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"pt-5 px-5",attrs:{"cols":"12"}},[_c('TabellaRegole')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }